/* eslint-disable react/no-unescaped-entities */
import Reveal from "./Reveal";
import { LANDING } from "@/constants/testIds";

const assetUrl = (u) => (!u ? "" : u.startsWith("http") ? u : `${process.env.REACT_APP_BACKEND_URL}${u}`);

export default function Hero({ onStartPlanting, siteContent }) {
  const heroImg = siteContent?.green_gift_hero || "";
  const heroImageStyle = heroImg
    ? { backgroundImage: `url(${assetUrl(heroImg)})` }
    : undefined;
  return (
    <section className="hero" id="give-back">
      <div className="hero-left">
        <Reveal className="hero-eyebrow">The Green Gift Initiative</Reveal>
        <Reveal as="h1" delay={1} className="hero-h1">One Gift.</Reveal>
        <Reveal as="h1" delay={2} className="hero-h2">One Tree.</Reveal>
        <Reveal as="p" delay={3} className="hero-body">
          At Utsah, every box you order plants a tree in a verified reforestation project — with your company's name on it. Business should give back. Through every gift you send, we help you celebrate your people while contributing to a greener India.
        </Reveal>
        <Reveal delay={3} className="hero-cta-row">
          <button
            className="hero-cta"
            data-testid={LANDING.heroStartPlanting}
            onClick={onStartPlanting}
          >
            Start Planting
            <svg width="18" height="12" viewBox="0 0 18 12" fill="none" aria-hidden>
              <path d="M1 6h15M11 1l5 5-5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
          <div className="hero-meta">
            <span className="hero-meta-dot" />
            <span>Verified by Grow-Trees</span>
          </div>
        </Reveal>
      </div>
      <div className="hero-right">
        <div className="hero-image" style={heroImageStyle} data-testid="landing-hero-image" />
        <div className="hero-decor" aria-hidden>1</div>
      </div>
    </section>
  );
}
